export const rules = {
  office: [{ required: true, message: '输入职位名称', trigger: 'blur' }]
}

export const deprules = {
  office: [{ required: true, message: '输入部门名称', trigger: 'blur' }]
}
